/**
 * NOTE: when permanent is used – the method's response is invalidated
 * on Global, Manifest, and Invalidate change events via the decorator.
 * It is used across all ManifestResolver methods.
 *
 * stored in the separated files to allow unit tests to work correctly
 */
export enum MethodCacheStrategy {
  Permanent = 'permanent',
  EventLoopTick = 'event-loop-tick',
  SiteUpdate = 'site-update',
  PresetUpdate = 'preset-update',
  PresetOrStateUpdate = 'preset-and-state-update',
  StateUpdate = 'state-update',
  DataUpdate = 'data-update',
  StylesUpdate = 'styles-update',
}
